import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Divider from "../components/Divider";
import anime from 'animejs';
import "./Services.css";

const Services = () => {
    const [isVisible, setIsVisible] = useState(false);
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);
    const servicesRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    
                    // Title animation
                    anime({
                        targets: titleRef.current,
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 200,
                    });

                    // Subtitle animation
                    anime({
                        targets: subtitleRef.current,
                        translateY: [30, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 500,
                    });

                    // Services animation
                    anime({
                        targets: '.service-card',
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1000,
                        delay: anime.stagger(200),
                        begin: () => {
                            anime.set('.service-card', { opacity: 0, translateY: 50 });
                        }
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(titleRef.current);
        observer.observe(subtitleRef.current);
        observer.observe(servicesRef.current);

        return () => observer.disconnect();
    }, [isVisible]);

    const services = [
        {
            title: "Πώληση Ελάτων",
            description: "Προσφέρουμε έλατα υψηλής ποιότητας σε διάφορα μεγέθη, ιδανικά για την περίοδο των Χριστουγέννων. Κάθε δέντρο επιλέγεται προσεκτικά για να διασφαλίσει την τέλεια συμμετρία και την υγιή ανάπτυξη.",
            icon: "🌲"
        },
        {
            title: "Καλλιέργεια",
            description: "Η καλλιέργεια των ελάτων γίνεται με μεράκι και φροντίδα, ακολουθώντας την παράδοση τριών γενεών. Χρησιμοποιούμε τις καλύτερες πρακτικές για να εξασφαλίσουμε την άριστη ανάπτυξη των δέντρων.",
            icon: "🌱"
        },
        {
            title: "Διακόσμηση",
            description: "Προσφέρουμε υπηρεσίες διακόσμησης για τα έλατα, συμπεριλαμβανομένης της τοποθέτησης και της διακόσμησης με φωτιστικά στοιχεία. Βοηθάμε στην δημιουργία της τέλειας ατμόσφαιρας για τις γιορτές.",
            icon: "✨"
        },
        {
            title: "Μεταφορά",
            description: "Παρέχουμε υπηρεσίες μεταφοράς για τα έλατα, με εξειδικευμένο προσωπικό και κατάλληλα οχήματα. Εξασφαλίζουμε ασφαλή και άμεση παράδοση στο σημείο σας, με την προσεκτική μεταχείριση που χρειάζεται κάθε δέντρο.",
            icon: "🚛"
        }
    ];

    return (
        <div className="services-section" id="services">
            <Container>
                <div className="services-header text-center">
                    <h2 className={`section-title ${isVisible ? 'visible' : ''}`} ref={titleRef}>Υπηρεσίες</h2>
                    <p className={`section-subtitle ${isVisible ? 'visible' : ''}`} ref={subtitleRef}>
                        Ανακαλύψτε τις υπηρεσίες μας για τα χριστουγεννιάτικα έλατα
                    </p>
                </div>

                <div className="services-content" ref={servicesRef}>
                    <Row className="g-4">
                        {services.map((service, index) => (
                            <Col key={index} xs={12} sm={6} lg={3} className="d-flex">
                                <div className="service-card w-100">
                                    <div className="service-icon">{service.icon}</div>
                                    <h3>{service.title}</h3>
                                    <p>{service.description}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>
            <Divider/>
        </div>
    );
};

export default Services;
